<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img :src="topLogo" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">公司简介</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="copyright">
        <span>安徽金得电气设备有限公司 版权所有 <a href="http://www.beian.miit.gov.cn/" target="_blank" style="color: #fff">皖ICP备20003069号</a></span>
      </div>

      <div class="box">
        <div class="left">
          <el-tooltip class="item" effect="dark" placement="left">
            <div slot="content">
              <img :src="companyInfo.wxImg" alt style="width: 150px;"/>
              <div style="text-align: center; padding-top: 5px;">使用微信扫一扫联系我们</div>
            </div>
            <img class="iconImg" :src="companyInfo.wxIcon" alt />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="'联系电话：'+companyInfo.tel" placement="left">
            <img class="iconImg" :src="companyInfo.telIcon" alt />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="'邮箱：'+companyInfo.email" placement="left">
            <img class="iconImg" :src="companyInfo.emailIcon" alt />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="'地址：'+companyInfo.address" placement="left">
            <img class="iconImg" :src="companyInfo.addressIcon" alt />
          </el-tooltip>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      // isShow: false
    };
  },
  computed: {
    ...mapGetters(['topLogo', 'companyInfo'])
  },
  methods: {
    // handleSelect(key) {
      // this.isShow = this.defaultActive != key;
      // window.console.log(this.isShow);
    // }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

/*滚动条样式*/
body::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}
body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 70px;
    }
  }
}
.el-main {
  padding: 0 !important;
}
.copyright {
  height: 30px;
  background: #125688;
  text-align: center;
  /*position: absolute;*/
  /*bottom: 0px;*/
  width: 100%;
  span {
    color: #fff;
    line-height: 30px;
    margin-left: 3px;
    a{
      text-decoration: none;
    }
  }
}
.box {
  width: 55px;
  position: fixed;
  right: 0px;
  bottom: 200px;
  z-index: 1000;

  .left {
    width: 55px;
  }

  .item {
    margin: 4px;
  }

  .left .el-tooltip__popper{
    padding: 8px 10px;
  }

  .left img.el-tooltip.iconImg.item{
    height: 48px;
    width: 48px;
  }
}
</style>
<style scoped>
  header.el-header {
    height: 70px !important;
  }

  li.el-menu-item{
    font-size: 16px;
    height: 70px;
    line-height: 70px;
  }
</style>
